import { TagEntityUsageQuery, useTagEntityUsageQuery } from "gql/generated";
import { useState } from "react";

export type UseTagEntityUsageProps = {
  selectedTagId: string;
};

export const useTagEntityUsage = ({
  selectedTagId,
}: UseTagEntityUsageProps) => {
  // Load the entity usage data
  const { data, error, loading } = useTagEntityUsageQuery({
    variables: { id: selectedTagId },
    skip: !selectedTagId,
  });

  // State for the selected event
  const [selectedEvent, setSelectedEvent] = useState<
    TagEntityUsageQuery["tagEntityUsage"]["events"][0] | null
  >(null);

  return {
    entityUsageData: data?.tagEntityUsage,
    error,
    loading,
    selectedEvent,
    setSelectedEvent,
  };
};
